import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const TelegramIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
  </SvgIcon>
);

export default TelegramIcon;
